import { cn } from "@utils";

export type DiffLineType = "ctx" | "del" | "add";
export type DiffLine = { type: DiffLineType; text: string };

const lineClassName: Record<DiffLineType, string> = {
  ctx: "text-black/[.87]",
  del: "bg-red-100 text-red-800",
  add: "bg-green-100 text-green-800",
};
const gutter: Record<DiffLineType, string> = { ctx: "", del: "−", add: "+" };
const screenReaderPrefix: Record<DiffLineType, string> = {
  ctx: "",
  del: "Removed: ",
  add: "Added: ",
};

/** Line-based text diff: removed lines in red, added lines in green. */
export const DiffBlock = ({ lines }: { lines: DiffLine[] }) => (
  <div className="max-w-full overflow-hidden rounded border border-solid border-black/[.12] bg-white font-mono text-[11.5px] leading-[1.6]">
    {lines.map((line, index) => (
      <div
        key={index}
        data-line-type={line.type}
        className={cn(
          "grid grid-cols-[18px_minmax(0,1fr)] whitespace-pre-wrap py-[2px] pl-2 pr-[10px] [overflow-wrap:anywhere]",
          lineClassName[line.type]
        )}
      >
        <div aria-hidden="true" className="select-none font-medium">
          {gutter[line.type]}
        </div>
        <div>
          {screenReaderPrefix[line.type] && (
            <span className="sr-only">{screenReaderPrefix[line.type]}</span>
          )}
          {line.text || "\u00a0"}
        </div>
      </div>
    ))}
  </div>
);
